const { useCallback } = window.React;

export default function Modal({
    children,
    isModalOpen,
    className = "",
    onClose,
    ...props
}) {
    const dialogCallbackRef = useCallback(
        (node) => {
            const dialog = node;
            if (!dialog) return;

            if (isModalOpen && !dialog.open) {
                dialog.showModal();
				dialog.scrollTo({ top: 0, behavior: "smooth" });
            } else if (!isModalOpen && dialog.open) {
                dialog.close();
            }
        },
        [isModalOpen],
    );

    const handleBackdropClick = useCallback(
        (e) => {
            const dialog = e.target.closest("dialog");
            if (!dialog) return;

            dialog.close();
        },
        [onClose],
    );

    return (
        <dialog
            ref={dialogCallbackRef}
            className={className}
            onClick={handleBackdropClick}
            onClose={onClose}
            {...props}
        >
            {children}
        </dialog>
    );
}
